/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import React, {useState} from "react"
import { useStaticQuery, graphql } from "gatsby"
import SearchComponent from './Search/SearchComponente';

import Header from "./Header"
import Footer from "./Footer"
import CartCleaner from "./CartCleaner"
import MetaPageView from "./MetaPageView"
import PopupModal from "./PopupModal"


const Layout = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site { 
        siteMetadata {
          title
        }
      }
    }
  `)
    // console.log(searchQuery)
    const title = data?.site?.siteMetadata?.title || "Default Title";
  return (
    <>
      <CartCleaner />
      <MetaPageView />
      <Header siteTitle={title} updateSearchQuery={setSearchQuery}/>
      <div
        style={{
          margin: `0 auto`,
          maxWidth: `var(--size-content)`,
          padding: `var(--size-gutter)`,
        }}
      >
        <main>
          {searchQuery ? (
            <SearchComponent searchQuery={searchQuery} />
          ) : (
            children
          )}
        </main>
        <Footer />
      </div>
      <PopupModal />
    </>
  )
}

export default Layout
